//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  GetCertiniaTasksRequest,
  GetCertiniaTasksResponse,
} from '@apis/campaign-requests/sampling/campaigns/certiniaTasksApiModel';
import { deserializeCertiniaTask } from '@apis/campaign-requests/sampling/campaigns/certiniaTasksApiUtils';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const CERTINIA_TASKS_DEFAULT_ENDPOINT = '/api/v1/clients/campaigns';

const certiniaTasksFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> =>
  serializedGatewayFetch(
    'sampling_gateway',
    `${CERTINIA_TASKS_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );

/**
 * Gets Certinia tasks for a specific campaign
 *
 * GET /api/v1/clients/campaigns/:campaignId/certinia-tasks
 */
export const getCertiniaTasks = async (
  req: GetCertiniaTasksRequest,
  init?: RequestInit,
): Promise<GetCertiniaTasksResponse> => {
  const res = await certiniaTasksFetch(`/${req.campaignId}/certinia-tasks`, {
    ...init,
    method: 'GET',
  });

  const response = await res.json<GetCertiniaTasksResponse>((res) => ({
    total: res.total,
    data: res.data?.map(deserializeCertiniaTask),
  }));

  return response;
};
